import { createApi } from '@reduxjs/toolkit/query/react'
import { createPublicApiBaseQuery } from './apiClients'

export const mediasApi = createApi({
    reducerPath: 'mediasApi',
    baseQuery: createPublicApiBaseQuery('mediasApi', { baseUrl: `${process.env.REACT_APP_API_BASE_URL}/medias` }),
    tagTypes: ['Medias'],
    endpoints: (builder) => ({
        getMediasByCategory: builder.query({
            query: (args) => {
                const { categoryCode, searchByParent } = args;
                return {
                    url: `/${categoryCode}`,
                    params: { searchByParent },
                    method: 'GET'
                }
            },
            transformResponse: (response) => response,
            transformErrorResponse: (response) => response,
            providesTags: ['Medias']
        }),
    }),
})

export const { useGetMediasByCategoryQuery } = mediasApi
